module.exports = __webpack_public_path__ + "static/media/focusbaseIllustration.d78f05fc.jpg";